import { gql } from "@apollo/client";

export const GET_ALL_COLLABORATION_NEEDS = gql`
  query getCollaborationNeeds {
    allCollaborationNeeds {
      edges {
        node {
          id
          intId
          title
        }
      }
    }
  }
`;

export const GET_ENTITY_NAME = gql`
  query regal_entitry_list {
    allLegalEntity{
      edges {
        node {
          title
        }
      }
    }
  }
`
